import Mooring from './Mooring';
export default class MooringCheckList extends Mooring {
}
//# sourceMappingURL=MooringCheckList.js.map